import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import translationEN from "./locales/en/translation.json";
import translationSW from "./locales/sw/translation.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      sw: { translation: translationSW },
    },
    lng: "sw",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
